import React, { createContext, useState, useContext, useMemo } from 'react';

interface PartnerContextType {
  selectedPartnerId: string | null;
  setSelectedPartnerId: (partnerId: string | null) => void;
}

const PartnerContext = createContext<PartnerContextType | undefined>(undefined);

export const PartnerProvider: React.FC<{ children: any }> = ({ children }) => {
  const [selectedPartnerId, setSelectedPartnerId] = useState<string | null>(
    null
  );

  const providerValue = useMemo(
    () => ({ selectedPartnerId, setSelectedPartnerId }),
    [selectedPartnerId, setSelectedPartnerId]
  );

  return (
    <PartnerContext.Provider value={providerValue}>
      {children}
    </PartnerContext.Provider>
  );
};

export const usePartner = () => {
  const context = useContext(PartnerContext);
  if (!context) {
    throw new Error('usePartner must be used within a PartnerProvider');
  }
  return context;
};
